<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <div class="d-flex align-center mb-4">
      <DatePicker v-model="selectedDate" />
    </div>
    <v-data-table
      :headers="headers"
      :items="cajas"
      :items-per-page="perPage"
      :page="currentPage"
      :server-items-length="totalCajas"
      :loading="loading"
      @update:options="handleTableUpdate"
      class="elevation-1"
      :expanded="expanded"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            @input="handleSearch"
          ></v-text-field> -->
          <v-spacer></v-spacer>
          <!-- <v-btn color="primary" dark class="mb-2" @click="$emit('newItem')"
            >Cerrar caja</v-btn
          > -->
        </v-toolbar>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ formatDate(item.fecha) }}
      </template>
      <template v-slot:[`item.total_caja`]="{ item }">
        {{ item.total_caja }} €
      </template>
      <template v-slot:[`item.total_inicial`]="{ item }">
        {{ item.total_inicial }} €
      </template>
      <template v-slot:[`item.diferencia`]="{ item }">
        {{ item.diferencia }} €
      </template>
      <template v-slot:[`item.cambio_turno`]="{ item }">
        <v-icon v-if="item.cambio_turno" color="blue">
          mdi-check-circle-outline
        </v-icon>
        <span v-else> </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          v-if="userIsAdmin()"
          small
          class="mr-2"
          @click="editItem(item)"
          color="green"
        >
          mdi-pencil
        </v-icon>
        <!-- <v-icon
          v-if="userIsAdmin()"
          small
          @click="confirmDelete(item)"
          color="red"
        >
          mdi-delete
        </v-icon> -->
      </template>
      <template v-slot:expanded-row="{ item }">
        <tr
          v-if="item.observaciones && item.observaciones.trim() !== ''"
          class="expanded-detalle"
        >
          <td :colspan="headers.length">
            <div class="pa-4">{{ item.observaciones }}</div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="deleteDialog" max-width="300">
      <v-card>
        <v-card-title>Confirmar eliminación</v-card-title>
        <v-card-text
          >¿Está seguro de que desea eliminar esta entrada de caja?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false"
            >Cancelar</v-btn
          >
          <v-btn color="red darken-1" text @click="deleteConfirmed"
            >Eliminar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import { useCajaStore } from '@/stores/cajaStore'
// import { useAuthStore } from '@/stores/authStore'
import { formatDate, userIsAdmin, userIsRecepcion } from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'
import DatePicker from '@/components/common/DatePicker.vue'

const emit = defineEmits(['edit'])

const cajaStore = useCajaStore()
// const authStore = useAuthStore()
const loading = ref(true)
const selectedDate = ref(null)

const search = ref('')

const headers = [
  { title: 'Fecha', key: 'fecha', align: 'center' },
  { title: 'Turno', key: 'turno', align: 'center' },
  { title: 'Usuario', key: 'usuario_iniciales', align: 'center' },
  { title: 'Total caja', key: 'total_caja', align: 'end' },
  { title: 'Total anterior', key: 'total_inicial', align: 'end' },
  { title: 'Descuadre', key: 'diferencia', align: 'end' },
  { title: 'Cambio turno', key: 'cambio_turno', align: 'center' },
  { title: '', key: 'data-table-expand' },
  {
    title: '  ',
    width: '100px',
    key: 'actions',
    sortable: false,
    align: 'end'
  }
]

const cajas = computed(() => cajaStore.cajas)
const totalCajas = computed(() => cajaStore.totalCajas)
const perPage = computed(() => cajaStore.perPage)
const currentPage = computed(() => cajaStore.page + 1)
// Computed property para mantener expandidas todas las filas
// const expandedItems = computed(() =>
//   cajas.value.filter((item) => item.observaciones !== '').map((item) => item.id)
// )
const expanded = ref([])

const loadCajas = async (options = {}) => {
  loading.value = true
  try {
    let fecha = selectedDate.value || null
    // No es necesario verificar si es Date, ya que selectedDate siempre debe ser string

    await cajaStore.fetchCajas({
      page: options.page,
      perPage: options.itemsPerPage,
      search: search.value,
      fecha: fecha
    })
  } catch (error) {
    console.error('Error loading cajas:', error)
    // Handle error (e.g., show error message to user)
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  // Inicializar con la fecha actual en formato ANSI
  const today = cajaStore.lastCaja?.fecha || new Date()
  if (today instanceof Date) {
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    selectedDate.value = `${year}-${month}-${day}`
  } else {
    selectedDate.value = today
  }

  await loadCajas()
})

// Observar cambios en la fecha seleccionada
watch(selectedDate, () => {
  loadCajas({ page: 1 })
})

const handleTableUpdate = (options) => {
  loadCajas(options)
}

// const handleSearch = () => {
//   cajaStore.setSearch(search.value)
//   loadCajas({ page: 1 })
// }

const editItem = (item) => {
  emit('edit', item)
}

// const confirmDelete = async (item) => {
//   if (confirm('¿Está seguro que desea eliminar esta entrada de caja?')) {
//     try {
//       await cajaStore.deleteCaja(item.id, authStore.token)
//       await loadCajas()
//     } catch (error) {
//       console.error('Error deleting caja:', error)
//       // Handle error (e.g., show error message to user)
//     }
//   }
// }
</script>
